import { fromPairs } from 'lodash';

import { useStoreData } from '../useStoreData';

/**
 * Allows to select Storyblok's strings that are present in application state.
 * Storyblok strings are loaded in application Preloader.
 *
 * TODO: Add types
 */
export const useStoryblokStrings = (name: any) => {
    const strings = useStoreData().storyblok.StringsItems.items.find(
        (s: any) => s.slug === name,
    )?.content.strings;

    if (!strings) return null;

    return fromPairs(strings.map((s: any) => [s.name, s.value])) as any;
};
